import PropTypes from "prop-types";

export const actionShape = {
  text: PropTypes.string,
  onClick: PropTypes.func,
};
